import script from "./period-selection-trigger.vue?vue&type=script&lang=ts&setup=true"
export * from "./period-selection-trigger.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__